// src/components/Sidebar.jsx

import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { ROLE_GROUPS, ROLES, getUserRoles, hasAnyRole } from '../utils/permissions';
import { canAccessModulePath } from '../utils/permissions';
import { useModules } from '../contexts/ModuleContext';
import './Sidebar.css';

const menuGroups = [
  {
    key: 'producao',
    title: 'Produção',
    icon: 'bi-diagram-3',
    items: [
      { label: 'Fazenda', path: '/propriedades', icon: 'bi-house-check', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Talhões', path: '/talhoes', icon: 'bi-grid-1x2', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Safras', path: '/safras', icon: 'bi-calendar4-week', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Plantio', path: '/plantios', icon: 'bi-flower1', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Fluxo do Plantio', path: '/fluxo-plantio', icon: 'bi-signpost-split', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Colheita', path: '/colheitas', icon: 'bi-basket-fill', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Operações', path: '/operacoes-campo', icon: 'bi-journal-text', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Mapa da Fazenda', path: '/mapa-fazenda', icon: 'bi-map', roles: ROLE_GROUPS.operacionalAgricultor },
    ],
  },
  {
    key: 'pecuaria',
    title: 'Pecuária',
    icon: 'bi-collection',
    items: [
      { label: 'Rebanho e criação animal', path: '/pecuaria', icon: 'bi-collection', roles: ROLE_GROUPS.operacionalAgricultor },
    ],
  },
  {
    key: 'estoque',
    title: 'Estoque',
    icon: 'bi-boxes',
    items: [
      { label: 'Insumos', path: '/insumos', icon: 'bi-box-seam', roles: ROLE_GROUPS.operacional },
      { label: 'Compra de Insumos', path: '/compras-insumos', icon: 'bi-cart-plus', roles: ROLE_GROUPS.operacional },
      { label: 'Aplicações', path: '/aplicacoesinsumo', icon: 'bi-droplet', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Armazém e venda', path: '/producao-agricola', icon: 'bi-boxes', roles: ROLE_GROUPS.operacionalAgricultor },
    ],
  },
  {
    key: 'financeiro',
    title: 'Financeiro e Fiscal',
    icon: 'bi-bank',
    items: [
      { label: 'Lançamentos', path: '/contasPagarReceber', icon: 'bi-arrow-left-right', roles: ROLE_GROUPS.financeiro },
      { label: 'Controle Financeiro Agro', path: '/financeiro/controle-agro', icon: 'bi-graph-up-arrow', roles: ROLE_GROUPS.financeiro },
      { label: 'Categorias Financeiras', path: '/categoriafinanceira', icon: 'bi-tags', roles: ROLE_GROUPS.financeiro },
      { label: 'Exportação bancária', path: '/financeiro/exportacao-bancaria', icon: 'bi-bank', roles: ROLE_GROUPS.financeiro },
    ],
  },
  {
    key: 'logistica',
    title: 'Logística',
    icon: 'bi-truck',
    items: [
      { label: 'Romaneio', path: '/romaneio-safra', icon: 'bi-truck', roles: ROLE_GROUPS.operacional },
      { label: 'Transportadoras', path: '/transportadoras', icon: 'bi-truck-flatbed', roles: ROLE_GROUPS.operacional },
      { label: 'Máquinas', path: '/maquinas', icon: 'bi-truck-front', roles: ROLE_GROUPS.operacional },
    ],
  },
  {
    key: 'fiscal',
    title: 'Fiscal',
    icon: 'bi-receipt',
    items: [
      { label: 'Nota Fiscal', path: '/notas-fiscais', icon: 'bi-receipt', roles: ROLE_GROUPS.fiscal },
      { label: 'CT-e / Frete', path: '/cte', icon: 'bi-truck', roles: ROLE_GROUPS.financeiroOperacional },
      { label: 'Certificado Digital', path: '/configuracoes/certificado', icon: 'bi-shield-lock', roles: ROLE_GROUPS.fiscal },
    ],
  },
  {
    key: 'configuracoes',
    title: 'Configurações',
    icon: 'bi-gear',
    items: [
      { label: 'Produtor Rural', path: '/agricultores', icon: 'bi-person-vcard', roles: ROLE_GROUPS.operacionalAgricultor },
      { label: 'Clientes', path: '/cliente', icon: 'bi-person-badge', roles: ROLE_GROUPS.financeiro },
      { label: 'Fornecedores', path: '/fornecedor', icon: 'bi-truck', roles: ROLE_GROUPS.financeiro },
      { label: 'Usuários', path: '/usuarios', icon: 'bi-person-lines-fill', roles: ROLE_GROUPS.administracao },
      { label: 'Auditoria', path: '/auditoria', icon: 'bi-shield-check', roles: ROLE_GROUPS.administracao },
      { label: 'Assinaturas', path: '/assinaturas', icon: 'bi-shield-lock', roles: ROLE_GROUPS.plataforma },
    ],
  },
  {
    key: 'relatorios',
    title: 'Relatórios',
    icon: 'bi-bar-chart-line',
    items: [
      { label: 'Painel', path: '/menu', icon: 'bi-house-door', roles: ROLE_GROUPS.todosTenant },
      { label: 'Fluxo do ERP', path: '/fluxo-erp', icon: 'bi-diagram-3', roles: ROLE_GROUPS.todosTenant },
      { label: 'Relatório Integrado', path: '/relatorios/integrado', icon: 'bi-columns-gap', roles: ROLE_GROUPS.financeiroOperacional },
      { label: 'Relatório Financeiro', path: '/relatorios/financeiro', icon: 'bi-file-earmark-bar-graph', roles: ROLE_GROUPS.financeiro },
      { label: 'Por Produtor', path: '/relatorioagricolaagricultor', icon: 'bi-file-earmark-text', roles: ROLE_GROUPS.relatoriosOperacionais },
      { label: 'Por Fazenda', path: '/relatorioagricolapropriedade', icon: 'bi-file-earmark-text', roles: ROLE_GROUPS.relatoriosOperacionais },
      { label: 'Operações de Campo', path: '/relatorios/operacoes-campo', icon: 'bi-journal-text', roles: ROLE_GROUPS.relatoriosOperacionais },
      { label: 'Colheita', path: '/relatorios/colheita', icon: 'bi-basket2-fill', roles: ROLE_GROUPS.relatoriosOperacionais },
      { label: 'Aplicações', path: '/relatorios/aplicacoes', icon: 'bi-beaker', roles: ROLE_GROUPS.relatoriosOperacionais },
    ],
  },
];

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { token, setToken } = useContext(AuthContext);
  const [openGroups, setOpenGroups] = useState({ producao: true });
  const [mobileOpen, setMobileOpen] = useState(false);
  const userRoles = getUserRoles(token);
  const isPlatformAdmin = userRoles.includes(ROLES.PLATFORM_ADMIN);
  const { modules } = useModules();

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
    navigate('/login');
  };

  const toggleGroup = (key) => {
    setOpenGroups(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <>
      <button
        type="button"
        className="sidebar-mobile-toggle"
        aria-label={mobileOpen ? 'Fechar menu' : 'Abrir menu'}
        aria-expanded={mobileOpen}
        onClick={() => setMobileOpen(open => !open)}
      >
        <i className={`bi ${mobileOpen ? 'bi-x-lg' : 'bi-list'}`} />
      </button>
      <button
        type="button"
        className={`sidebar-mobile-backdrop ${mobileOpen ? 'open' : ''}`}
        aria-label="Fechar menu"
        tabIndex={mobileOpen ? 0 : -1}
        onClick={() => setMobileOpen(false)}
      />
      <aside className={`sidebar-erp ${mobileOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-brand">
        <img className="sidebar-brand-logo" src="/CultivaMaisLogo.png" alt="Cultiva Mais" />
      </div>

      <nav className="sidebar-nav" aria-label="Menu principal">
        {!isPlatformAdmin && canAccessModulePath('/menu', modules) && <Link className={`sidebar-link ${isActive('/menu') ? 'active' : ''}`} to="/menu">
          <i className="bi bi-house-door" />
          <span>Painel</span>
        </Link>}
        {isPlatformAdmin && <Link className={`sidebar-link ${isActive('/assinaturas') ? 'active' : ''}`} to="/assinaturas">
          <i className="bi bi-building-gear" />
          <span>Painel da Plataforma</span>
        </Link>}
        {isPlatformAdmin && <Link className={`sidebar-link ${isActive('/novidades-admin') ? 'active' : ''}`} to="/novidades-admin">
          <i className="bi bi-megaphone" />
          <span>Gerenciar novidades</span>
        </Link>}
        <Link className={`sidebar-link ${isActive('/novidades') ? 'active' : ''}`} to="/novidades">
          <i className="bi bi-stars" />
          <span>Novidades</span>
        </Link>
        {!isPlatformAdmin && hasAnyRole(userRoles, ROLE_GROUPS.financeiroOperacional) && canAccessModulePath('/ferramentas-gestao', modules) && (
          <Link className={`sidebar-link ${isActive('/ferramentas-gestao') ? 'active' : ''}`} to="/ferramentas-gestao">
            <i className="bi bi-lightbulb" />
            <span>Ferramentas de Gestão</span>
          </Link>
        )}
        {!isPlatformAdmin && hasAnyRole(userRoles, ROLE_GROUPS.todosTenant) && canAccessModulePath('/importacao-dados', modules) && (
          <Link className={`sidebar-link ${isActive('/importacao-dados') ? 'active' : ''}`} to="/importacao-dados">
            <i className="bi bi-file-earmark-arrow-up" />
            <span>Importar dados</span>
          </Link>
        )}
        {hasAnyRole(userRoles, ROLE_GROUPS.administracao) && canAccessModulePath('/onboarding-inicial', modules) && (
          <Link className={`sidebar-link ${isActive('/onboarding-inicial') ? 'active' : ''}`} to="/onboarding-inicial">
            <i className="bi bi-list-check" />
            <span>Primeiros passos</span>
          </Link>
        )}

        {!isPlatformAdmin && <ul className="nav flex-column">
          {menuGroups.map(group => {
            const items = group.items.filter(item => hasAnyRole(userRoles, item.roles) && canAccessModulePath(item.path, modules));

            if (!items.length) {
              return null;
            }

            return (
            <li className="nav-item" key={group.key}>
              <button
                type="button"
                className="sidebar-group-toggle"
                onClick={() => toggleGroup(group.key)}
              >
                <span>
                  <i className={`bi ${group.icon}`} />
                  {group.title}
                </span>
                <i className={`bi bi-chevron-${openGroups[group.key] ? 'down' : 'right'}`} />
              </button>

              {openGroups[group.key] && (
                <ul className="nav flex-column sidebar-submenu">
                  {items.map(item => (
                    <li className="nav-item" key={item.path}>
                      <Link
                        className={`sidebar-link sidebar-sublink ${isActive(item.path) ? 'active' : ''}`}
                        to={item.path}
                      >
                        <i className={`bi ${item.icon}`} />
                        <span>{item.label}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
          })}
        </ul>}
      </nav>

      <button onClick={handleLogout} className="sidebar-logout">
        <i className="bi bi-box-arrow-left" />
        <span>Sair</span>
      </button>
      </aside>
    </>
  );
}

export default Sidebar;
